<template>
  <div class="container">
    <div id="page1-div" class="container interline border page-container">
      <div class="col-12 p-4">
        <div class="col-12 text-right pt-5 pb-3 ">
          <span class="ft12Black">
            <span class="ft11"
              >CD,
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.municipio_cliente }},
              </span>
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.estado_cliente }}</span
              >
              a
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.fecha_contrato }}.
              </span>
            </span>
          </span>
        </div>
        <div class="col-6 pt-4 pb-3">
          <span class="ft12Black">
            SR(A).
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.nombre_cliente }}
            </span>
            <br />
            N° CUENTA:
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.No_Operacion_Cliente }}
            </span>
          </span>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft11">
            &emsp; &emsp;Ahora usted forma parte de la cartera de clientes de
            GPI AUTO COMERCIAL SAPI DE C.V. y por ello le presentamos a
            continuación y le proporcionamos una serie de información que le
            ayudarán a mantener su cuenta de la mejor manera posible.
            <br /><br />
            &emsp; &emsp;Recuerde que mantener cuentas sanas le abrirá la
            posibilidad de adquirir con mayor facilidad un sin número de todo
            tipo de créditos.
            <br />
            <br />
            <u class="ft11Black">Forma de pago</u>
            <br />
            <br />
            &emsp; &emsp;Actualmente tenemos a su disposición una cuenta
            bancaria a nombre de GPI AUTO COMERCIAL SAPI DE C.V. para que pueda
            realizar sus pagos y usted podrá elegir la opción que le parezca más
            cómoda para realizar sus pagos ya sea mediante depósitos en
            ventanilla o transferencias las cuales son:
          </span>
        </div>
        <div class="col-12 text-center ">
          <span class="ft12Black">
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.banco }}
            </span>
            <br />
            CONVENIO CIE: 5524
            <br />
            CUENTA: {{ data.cuenta_banco }}
            <br />
            CLABE INTERBANCARIA: {{ data.clave_banco }}
            <br />
          </span>
        </div>
        <!-- <div class="col-12 text-justify">
          <span class="ft11">
            <br />
            &emsp; &emsp;Para realizar sus pagos usted contara con un número de
            concepto, este es un número único y personalizado de depósito
            mediante el cual se direccionarán a su crédito todos los depósitos
            que realice. En caso de realizar pago vía transferencia su
            referencia deberá de colocarse en el apartado “CONCEPTO DE PAGO” sin
            espacio, sin guiones y/o alguna otra descripción (solo los números)
            de lo contrario será rechazado el movimiento por el banco.
          </span>
          <br />
          <br />
        </div> -->
        <div class="col-12 text-justify">
          <span class="ft11">
            <br />
            &emsp; &emsp;Así mismo, le informamos que en breve contará con
            un número de referencia personal con el cual se direccionarán a su
            crédito todos los depósitos que usted realice, mientras esto ocurre,
            favor de colocar su numero de contrato en el campo de concepto como
            se muestra en el ejemplo.
          </span>
          <br />
          <br />
        </div>
        <div class="col-12 text-center">
          <span class="ft11Black">
            Su número de concepto / referencia es
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.referencia_banco }}
            </span>
            <br />
            <br />
          </span>
        </div>
        <div class="col-12 text-justify">
          <span class="ft11">
            &emsp; &emsp;La ficha de depósito le servirá a usted como
            comprobante de pago ante nosotros por lo que le recomendamos
            conservarlos para cualquier aclaración.
            <br />
            <br />
            &emsp; &emsp;Le reiteramos que es importante
            <span class="ft11Black">no retrasarse</span> en el pago de sus
            mensualidades cuya fecha de vencimiento inicia a partir del
            <span class="ft11Black">
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.fecha_primer_pago }}
              </span> </span
            >por un monto de
            <span class="ft11Black">
              <span v-bind:class="{ marca: data.showMarca }">
                ${{ data.mensualidad }} {{ data.mensualidad_letra }},
              </span>
            </span>
            en caso de que su fecha de vencimiento caiga en fin de semana o día
            inhábil el pago lo tendrá que efectuar el día hábil anterior, de no
            hacerse de esta manera se le generaran cargos por pago extemporáneo
            y por consiguiente deberá de realizar su pago por un importe mayor
            al de su mensualidad.
            <br />
            <br />
            &emsp; &emsp;En caso de que haya presentado atraso y solo pague el
            importe de su mensualidad del pago que realice primero se
            descontarán los recargos, el resto se abonará a su mensualidad
            quedando un saldo pendiente el cual podrá afectar su buro de
            crédito, es por ello que recomendamos se realice el depósito de
            acuerdo a la situación del pago para ello favor de comunicarse al
            3310782828 y ext 1117, 1118 y 1120 a atención a clientes de GPI Auto
            Comercial para que le proporcionen el saldo actualizado.
            <br />
            <br />
            &emsp; &emsp;Sin más por el momento, nos despedimos de usted no sin
            antes ponernos a sus órdenes para cualquier aclaración ó duda que
            pudiera surgir al respecto y agradecerle su preferencia por GPI Auto
            Comercial SAPI DE C.V. Al mismo tiempo de reiterarle nuestro
            interés en seguirle sirviendo.
          </span>
          <br />
        </div>
        <div class="col-12 row pt-4 pb-5 pl-4">
          <span class="ft13">
            Atentamente
          </span>
        </div>
        <div class="col-12 row pt-4">
          <div class="col-6 ">
            <span class="ft13">
              GPI AUTO COMERCIAL SAPI DE C.V.
              <br />
              Atención a clientes 3311535434
            </span>
          </div>
          <div class="col-1 text-center"></div>
          <div class="col-4 border-bottom border-dark text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/referenciaRecursosPropios.vue